import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { 
    Info,
} from "lucide-react"
import {
    getFaqList
} from "../../../../../redux/faq/faqState";

const FAQ = ({
    recordList,
    pagination, 
	doSearch, 
}) => {

useEffect(() => {
    doSearch({ paginate: pagination?.per_page});
}, [doSearch, pagination?.per_page]);
    return (
        <Card className="space-y-6">
            <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200">
                <div className=" grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6">
                    <h4 className="leading-none flex items-center gap-2">
                        <Info className="w-5 h-5 text-emerald-600" />
                        Frequently Asked Questions
                    </h4>
                    <p className="text-slate-700">
                        Find answers to common questions
                    </p>
                </div>
                <div className="px-6 pb-6">
                    <div className="space-y-3">
                        {recordList?.map((recordData) => (
                            <div
                                key={recordData?.faq_id}
                                className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200"
                            >
                                <div className="pb-6 p-4">
                                    <h4 className="font-semibold text-sm mb-2">
                                        {recordData?.faq_question}
                                    </h4>
                                    <p className="text-sm text-slate-700 tracking-normal">
                                        {recordData?.faq_answer}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Card>
    )
};

const mapStateToProps = (state) => ({
    recordList: state.faq.faqList?.items,
    pagination: state.faq.faqList?.pagination,
	filters: state.faq.faqList?.filters,
	requesting: state.faq.faqList?.requesting,
	error: state.faq.faqList?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getFaqList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FAQ);